import { RelationshipImportantOptionsType } from './types';

export const RELATIONSHIP_IMPORTANT_OPTIONS: RelationshipImportantOptionsType =
  [
    { id: 'trust_honesty', title: 'Trust & honesty', icon: '🤝' },
    { id: 'communication', title: 'Communication', icon: '💬' },
    { id: 'physical_chemistry', title: 'Physical chemistry', icon: '💞' },
    { id: 'shared_goals', title: 'Shared goals & dreams', icon: '🚀' },
    { id: 'independence', title: 'Independence & space', icon: '🙆‍♂️' },
  ];
